import { Component, ComponentInterface, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-table-row',
  styleUrl: 'signet-table.scss',
  shadow: false,
  scoped: false,
})
export class SignetTableRow implements ComponentInterface {
  @Prop() row: number;

  render() {
    return (
      <tr
        class={`signet-table-row`}
        style={{
          'grid-template-columns': `repeat(${this.row}, minmax(0, 1fr)`,
        }}
      >
        <slot></slot>
      </tr>
    );
  }
}
